export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

export const ALL_POSITIONS = 'All_POSITIONS';
export const ALL_WORK_LOCATIONS = 'ALL_WORK_LOCATIONS';
export const STORE_PUNISHMENT_REWARD_TYPE = 'STORE_PUNISHMENT_REWARD_TYPE';

export const STORE_TRAININGS = 'STORE_TRAININGS';
export const STORE_TRAINING_EVALUATION_TYPES = 'STORE_TRAINING_EVALUATION_TYPES';

export const STORE_REMINDERS = 'STORE_REMINDERS';
export const STORE_REMINDERS_TYPES = 'STORE_REMINDERS_TYPES';

export const STORE_EVALUATIONS = 'STORE_EVALUATIONS';
export const STORE_EVALUATIONS_TYPES = 'STORE_EVALUATIONS_TYPES';

export const ACTIVE_EMPLOYEE = 'ACTIVE_EMPLOYEE';
export const DIS_ACTIVATE_EMPLOYEE = 'DIS_ACTIVATE_EMPLOYEE';

export const STORE_SLICES = 'STORE_SLICES';
export const STORE_LEVELS = 'STORE_LEVELS';
export const STORE_RECOMPENSES = 'STORE_RECOMPENSES';
export const STORE_DEDUCTIONS = 'STORE_DEDUCTIONS';
export const STORE_SALARY_EQUATIONS = 'STORE_SALARY_EQUATIONS';

export const STORE_LEAVES_TYPE = 'STORE_LEAVES_TYPE'

export const STORE_TASKS_TYPES = 'STORE_TASKS_TYPES'

export const STORE_WORK_PLACES = 'STORE_WORK_PLACES'

export const USERS = 'USERS'

export const STORE_DETAILS_TYPES = 'STORE_DETAILS_TYPES'

export const STORE_ROLE = 'STORE_ROLE'

export const STORE_PERMISSION_TYPE = 'STORE_PERMISSION_TYPE'

export const STORE_HOLIDAY = 'STORE_HOLIDAY'